import { getStandaloneOrigin } from "../utils/origin.utils";
import { isPspMode } from "./pspMode";

/**
 * Matches an absolute or protocol-relative URL (e.g. `https://…`, `data:…`,
 * `blob:…`, `//host/path`). These are passed through `getPspUrl` untouched.
 */
const ABSOLUTE_URL_PATTERN = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;

/**
 * Rewrite a URL to the standalone (controlpanel) origin so requests fired
 * from a non-controlpanel host (e.g. PSP) hit the right backend.
 *
 * - Absolute URLs (e.g. `https://host/path`, `data:…`, protocol-relative
 *   `//host/…`) are returned unchanged.
 * - Path-absolute URLs (leading `/`) are prefixed with `getStandaloneOrigin()`.
 * - Bare-relative URLs (e.g. `foo/bar`, `./foo/bar`) are passed through
 *   unchanged; they will resolve against the current document path.
 */
export function getPspUrl(url: string): string {
  if (ABSOLUTE_URL_PATTERN.test(url)) return url;
  if (url.startsWith("/")) return `${getStandaloneOrigin()}${url}`;
  return url;
}

/**
 * Resolve a URL for the current host mode.
 *
 * In PSP mode the URL is rewritten to the standalone origin via `getPspUrl`.
 * In standalone mode the input is returned unchanged so existing relative
 * paths continue to resolve against the current document.
 */
export function resolveUrl(url: string): string {
  return isPspMode() ? getPspUrl(url) : url;
}
